<span
  [style]="
    color
      ? {
          color: 'var(' + '--' + color + ')'
        }
      : ''
  "
  #icon
  [class]="'jam jam-' + name"
  [style.fontSize]="fontSize + 'px'"
></span>
